import React from 'react';
import {
  Flex,
  Box,
  Text,
  Button,
  Icon,
  Avatar,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverCloseButton,
} from '@chakra-ui/react';
import { IoChevronForward } from 'react-icons/io5';
import { FaSignOutAlt, FaSignInAlt } from 'react-icons/fa';

import { googleSignin, signOut } from '../../services/authService';
import useCurrentUser from '../../hooks/useCurrentUser';
import { useTrackedState } from '../../config/store';

function ProfilePopover() {
  const { loading, loaded, isAuthenticated } = useCurrentUser();
  const state = useTrackedState();

  return (
    <Popover trigger='hover'>
      <PopoverTrigger>
        <Box
          h='100%'
          fontSize='12px'
          fontWeight='600'
          color='gray.700'
          sx={{
            cursor: 'pointer',
            ':hover': {
              backgroundColor: 'gray.50',
              textDecor: 'underline',
            },
          }}>
          <Flex alignItems='center' h='100%' p='24px'>
            {!isAuthenticated && !loading && <Text>Sign In</Text>}
            {loading && <Text>Signing In...</Text>}
            {isAuthenticated && loaded && <Text>{state.user?.name}</Text>}

            <Icon as={IoChevronForward} />
          </Flex>
        </Box>
      </PopoverTrigger>
      <PopoverContent
        bg='white'
        w='unset'
        minW='320px'
        borderRadius='16px'
        boxShadow='0px 41px 60px 11px rgba(161, 161, 161, 0.160047)'>
        <PopoverCloseButton />
        <PopoverBody p='24px'>
          <Flex flexDirection='column' alignItems='center'>
            <Box>
              <Avatar name={state.user?.name} src={state.user?.imageUrl} size='xl' />
            </Box>
            <Text fontSize='18px' fontWeight='700' mt='12px'>
              {state.user?.name}
            </Text>
            <Text fontSize='18px' mb='24px'>
              {state.user?.email}
            </Text>

            {!isAuthenticated && !loading && (
              <Button size='lg' colorScheme='blue' rightIcon={<FaSignInAlt />} onClick={() => googleSignin()}>
                SIGN IN
              </Button>
            )}
            {isAuthenticated && loaded && (
              <Button size='lg' colorScheme='blue' rightIcon={<FaSignOutAlt />} onClick={() => signOut()}>
                SIGN OUT
              </Button>
            )}
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}

export default ProfilePopover;
